import { render, staticRenderFns } from "./agent_tab.vue?vue&type=template&id=081dc1db&"
import script from "./agent_tab.vue?vue&type=script&lang=js&"
export * from "./agent_tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports